var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-528 -350)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M530.25 356.625 530.25 372.375 552.75 372.375 552.75 356.625 530.25 356.625ZM541.894 366.441C541.669 366.666 541.331 366.666 541.106 366.441L532.781 358.312 550.247 358.312 541.894 366.441ZM537.422 364.416 531.938 369.928 531.938 359.044 537.422 364.416ZM538.237 365.203 540.347 367.256C540.684 367.566 541.106 367.734 541.528 367.734 541.95 367.734 542.372 367.566 542.709 367.256L544.819 365.203 550.275 370.688 532.753 370.688 538.237 365.203ZM545.578 364.416 551.062 359.072 551.062 369.9 545.578 364.416Z",
    fill: "#4C39A0",
    fillRule: "nonzero",
    fillOpacity: 1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.49940ff65c839af612c4a1b542917c65.svg";
export { ForwardRef as ReactComponent };